import { defineMessages } from 'react-intl';

export default defineMessages({
    paymentPreferences: {
        id: 'views.components.claimsPreference.Payment Preference',
        defaultMessage: 'Payment Preference'
    },
    paymentOptions: {
        id: 'custom.views.agm.Would you like to receive claim payments?',
        defaultMessage: 'Would you like to receive claim payments?'
    },
    eftNote: {
        id: 'views.components.claimsPreference.EFT Note',
        defaultMessage: 'Please Note: Not all payments may be eligible for EFT payments. Would you like to continue?'
    },
    eftNoteTitle: {
        id: 'views.components.claimsPreference.EFT Note:',
        defaultMessage: 'Please Note:'
    },
    eftMessage: {
        id: 'views.components.claimsPreference.EFT Message Update',
        defaultMessage: 'Please note not all payments may be eligible for EFT delivery. In addition, please ensure the accuracy of any financial information input for EFT payments. Any inaccuracies are your responsibility and Heartland will not be liable for any loss or damage due to incorrect banking information input into our systems.'
    },
    btnLabelYes: {
        id: 'views.components.claimsPreference.Yes',
        defaultMessage: 'Yes'
    },
    btnLabelNo: {
        id: 'views.components.claimsPreference.No',
        defaultMessage: 'No'
    }

});
